import { Ref } from '@nuxtjs/composition-api'
import VueScrollTo, { ScrollOptions } from 'vue-scrollto'

export default function (
  el: Ref<Element | undefined>,
  options: ScrollOptions = {}
) {
  /** 滾動至指定元素處 */
  const scrollTo = () => {
    if (!el.value) return

    VueScrollTo.scrollTo(el.value, {
      offset: -48,
      ...options,
    })
  }

  return {
    scrollTo,
  }
}
